import { InvestorModule } from './pages/aside-left-display-disabled/investor/investor.module';
import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from "../auth/_guards/auth.guard";
import { UsersModule } from './pages/aside-left-display-disabled/users/users.module';
import { UnitsModule } from './pages/aside-left-display-disabled/units/units.module';
import { ConfigsModule } from './pages/aside-left-display-disabled/configs/configs.module';
import { InnerModule } from './pages/default/inner/inner.module';
import { ProfileModule } from './pages/default/profile/profile.module';
import { NotFoundModule } from './pages/default/not-found/not-found.module';
import { IndexModule } from './pages/aside-left-display-disabled/index/index.module';
import { IncomesModule } from './pages/aside-left-display-disabled/incomes/incomes.module';
import { ExpensesModule } from './pages/aside-left-display-disabled/expenses/expenses.module';
import { MonthlyCutModule } from './pages/aside-left-display-disabled/monthly-cut/monthly-cut.module';
import {
    LesseeEditComponent, LesseeNewComponent, LesseesListComponent
} from './pages/aside-left-display-disabled/lessees';
import {
    AsideLeftDisplayDisabledComponent
} from './pages/aside-left-display-disabled/aside-left-display-disabled.component';

const routes: Routes = [
    {
        "path": "",
        "component": ThemeComponent,
        "canActivate": [AuthGuard],
        "children": [
            {
                "path": "index",
                "loadChildren": () => IndexModule
            },
            {
                "path": "users",
                "loadChildren": () => UsersModule
            },
            {
                "path": "investors",
                "loadChildren": () => InvestorModule
            },
            {
                "path": "units",
                "loadChildren": () => UnitsModule
            },
            {
                "path": "incomes",
                "loadChildren": () => IncomesModule
            },

            {
                "path": "expenses",
                "loadChildren": () => ExpensesModule
            },
            {
                "path": "monthly-cuts",
                "loadChildren": () => MonthlyCutModule
            },
            {
                "path": "inner",
                "loadChildren": () => InnerModule
            },
            {
                "path": "profile",
                "loadChildren": () => ProfileModule
            },
            {
                "path": "configs",
                "loadChildren": () => ConfigsModule
            },
            {
                "path": "404",
                "loadChildren": () => NotFoundModule
            },
            {
                "path": "lessees", // lessees to work with
                "component": AsideLeftDisplayDisabledComponent,
                "children": [
                    {
                        "path": "",
                        "component": LesseesListComponent
                    },
                    {
                        "path": "new",
                        "component": LesseeNewComponent
                    },
                    {
                        "path": ":id/edit",
                        "component": LesseeEditComponent
                    }
                ]
            },
            {
                "path": "",
                "redirectTo": "index",
                "pathMatch": "full"
            }
        ]
    },
    {
        "path": "**",
        "redirectTo": "404",
        "pathMatch": "full"
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ThemeRoutingModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/theme-routing.module.ts